export enum TimingState {
  Idle,
  Active,
  Warning,
  Overtime,
}